export const openJpKeys = ['jp_screening', 'jp_shortlist_formation', 'jp_shortlist_sent'];
